import { Asset } from 'components/common/types/Asset.types';
import { PlannerMapDataElement } from 'components/common/types/Planner.types';

type PickingObject = { geometry?: unknown; assets?: Asset[]; frameId?: string; longitude?: number };

export type GroupableAsset = Pick<Asset, 'furnitureCode' | 'longitude' | 'latitude'>;

export const areAllAssetsGrouped = (assets: GroupableAsset[]): boolean => {
  if (assets.length === 0) return false;

  const [{ furnitureCode, longitude, latitude }] = assets;

  return assets.every(
    (asset) =>
      (furnitureCode && asset.furnitureCode === furnitureCode) ||
      (longitude === asset.longitude && latitude === asset.latitude),
  );
};

const hasClickableProperties = (props: { frameId?: string; longitude?: number }): boolean =>
  props.frameId !== undefined || props.longitude !== undefined;

export const isClusterClickable = (cluster: PlannerMapDataElement | null | undefined): boolean => {
  if (!cluster?.properties) return false;

  const { assets } = cluster.properties;
  return assets && assets.length > 0 ? areAllAssetsGrouped(assets) : hasClickableProperties(cluster.properties);
};

export const isObjectClickable = (object: PickingObject | null | undefined): boolean => {
  if (!object || object.geometry || object.assets === undefined) return false;
  return object.assets.length > 0 ? areAllAssetsGrouped(object.assets) : hasClickableProperties(object);
};
